<style lang="less" scoped>
.work-flow {
  .title {
    font-size: 14px;
    color: #222327;
    line-height: 20px;
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    margin-right: 16px;
    color: #4680ff;
    border-bottom: 1px solid #eaecf2;
    padding-bottom: 12px;
  }
  &__box {
    display: flex;
    flex-wrap: wrap;
    &__node {
      padding-top: 8px;
      display: flex;
      align-items: center;
      &:last-child {
        margin-bottom: 0px;
        .node-depart::after {
          display: none;
        }
      }
      .node-form {
        flex: 1;
        margin-left: 27px;
      }
      .node-depart {
        width: 88px;
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        font-size: 12px;
        color: #5a5d68;
        text-align: center;
        position: relative;
        padding-right: 30px;
        &::after {
          content: "";
          position: absolute;
          width: 30px;
          height: 2px;
          background-color: #e4e5ea;
          right: 0px;
          top: 45px;
          z-index: 1;
        }
        &--name {
          font-size: 14px;
          font-weight: bold;
          color: #222327;
          padding-bottom: 8px;
          position: relative;
          background: #fff;
          z-index: 9;
        }
        .is-avatar {
          .avatar-append {
            display: none;
          }
          .avatar-name {
            display: block;
            background-color: #409eff;
          }
          span.success{
            background-color: #67C23A;
          }
          span.watting{
            background-color: #909399;
          }
          .status-text{
            font-size: 12px;
          }
          .round {
            position: absolute;
            display: flex;
            width: 16px;
            height: 16px;
            background-color: #f04961;
            border-radius: 50%;
            right: -2px;
            top: -2px;
            border: 1px solid #fff;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .el-icon-close {
              color: #fff;
              font-weight: bold;
            }
          }
        }
        &__avatar {
          width: 48px;
          height: 48px;
          position: relative;
          box-sizing: border-box;
          background: #fff;
          z-index: 9;
          .avatar-name {
            display: none;
          }
          .avatar-append {
            border-radius: 50%;
            height: 100%;
            width: 100%;
            border: 2px dashed #e4e5ea;
            box-sizing: border-box;
            cursor: pointer;
            position: relative;
            &::before {
              width: 2px;
              height: 20px;
              background-color: #91949f;
              content: "";
              display: block;
              position: absolute;
              left: calc(50% - 1px);
              top: calc(50% - 10px);
            }
            &::after {
              height: 2px;
              width: 20px;
              background-color: #91949f;
              content: "";
              display: block;
              position: absolute;
              top: calc(50% - 1px);
              left: calc(50% - 10px);
            }
          }
        }
        &__staff-name {
          color: #5a5d68;
          font-weight: 400;
          font-size: 12px;
          padding-top: 8px;
          padding-bottom: 8px;
          background-color: #fff;
          position: relative;
          z-index: 9;
          min-width: 2px;
          word-break: keep-all;
        }
      }
    }
  }
}
</style>
<template>
  <div :key="data.componentKey" class="work-flow">
    <div class="title">审核节点</div>
    <sz-dialog-staff v-model:visible="visible" v-model:expand="selectAuditUser" ext-tree :path-table="data.pathTable" :tree="data.tree" />
    <div class="work-flow__box">
      <div v-for="(node, index) in data.flowList" :key="index" class="work-flow__box__node">
        <div class="node-depart">
          <!-- 部门名称 -->
          <div class="node-depart--name">
            {{ (workType !== 'common_flow' && workType !== 'office_supplies_use' && workType !== 'seal_apply' && workType !== 'common_contract') ? node.taskName : '' }}
          </div>
          <div class="node-depart__avatar" :class="[node.assignee ? 'is-avatar' : '']">
            <!-- 头像 -->
            <div class="avatar-append" v-if="!showStatus" @click.stop="appendFn(node, index)"></div>
            <!-- 名字 -->
            <el-avatar class="avatar-name" v-if="!showStatus" :size="48">
              {{ node.assigneeName && node.assigneeName.substr(0, 1) }}
              <span class="round" @click.stop="deleFn(node, index)"><i class="el-icon-close"></i></span>
            </el-avatar>
            <!-- 名字 -->
            <el-avatar :class="{'success': index < data.currentApproval,'avatar-name': index === data.currentApproval,'watting': index > data.currentApproval}" v-if="showStatus && !showReviewerName" :size="48">
              <span class="status-text" v-if="index < data.currentApproval">已通过</span>
              <span class="status-text" v-if="index === data.currentApproval">审核中</span>
              <span class="status-text" v-if="index > data.currentApproval">待审核</span>
            </el-avatar>
            <!-- 名字 -->
            <el-avatar class="avatar-name" v-if="showStatus && showReviewerName" :size="48">
              {{ node.assigneeName && node.assigneeName.substr(0, 1) }}
            </el-avatar>
          </div>
          <div class="node-depart__staff-name">
            {{ node.assigneeName }}
          </div>
        </div>
      </div>
      <div v-if="(workType === 'common_flow' || workType === 'office_supplies_use' || workType === 'seal_apply' || workType === 'common_contract') && !showStatus" class="work-flow__box__node add-box">
        <div class="node-depart">
          <!-- 部门名称 -->
          <div class="node-depart__avatar">
            <!-- 头像 -->
            <div class="avatar-append" @click.stop="appendFn('')"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import {
  defineComponent,
  PropType,
  onMounted,
  reactive,
  toRef,
  toRefs,
  ref,
  computed,
  watch,
  onActivated
} from "vue";
import $api from "@/api/main";
import { ElMessage } from "element-plus";
import utils from "@/utils/utils";
export default defineComponent({
  props: {
    /**
     *  传入的当前流程信息
     */
    modelValue: {
      type: Object as PropType<any>,
      default: (): any => {
        return [];
      },
    },
    /**
     *  当前流程的信息
     */
    workflowType: {
      type: String,
      default: "",
    },
    /**
     *  当前流程是否显示状态
     */
    showStatus: {
      type: Boolean,
      default: false,
    },
    /**
     *  当前流程审核节点ID
     */
    currentTask:{
      type: String,
      default: "",
    },
    /**
     *  是否展示显示状态下的用户名称
     */
    showReviewerName:{
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const workType = props.workflowType;
    const selectAuditUser = ref();
    let selectNode: any = ref({});
    const visible = ref(false);
    const departmentDir: any = {
      材设部: "material",
      项目部: "engineering",
      经营部: "business",
      质安部: "engineering",
      综合部: "comprehensive",
      财务部: "finance",
      项目经理: "engineering",
      材料员: "material",
      预算员: "business",
      预算部经理: "business",
      财务员: "finance",
      财务员1: "finance",
      财务员2: "finance",
      行政员: "comprehensive",
      副总经理: "manager",
      总经理: "comprehensive",
      分管领导: "manager",
      质安员: "quality",
      质安负责人: "quality",
      质安部负责人: "quality",
      综合部领导: "comprehensive",
      部门领导: utils.$cookie.getCookie("hxStaffDept"),
      行政代总经理: "comprehensive",
    };

    const departmentCodeDir: any = {
      engineering: "工程部",
      finance: "财务部",
      material: "材设部",
      business: "经营部",
      quality: "质安部",
      comprehensive: "综合部",
      manager: "总经办",
    };

    const data: any = reactive({
      tree: [],
      flowList: props.modelValue,
      expand: [],
      pathTable: {},
      componentKey: new Date().getTime(),
      currentApproval: 0,
    });

    if(props.showStatus && (props.currentTask === '' || props.currentTask === 'null')){
      data.currentApproval = 99;
    }
    /**
     * 获取员工树
     */
    const createPathTable = (tree: any[], pathArray: any[], indexs: any[]) => {
      for (let index = 0; index < tree.length; index++) {
        pathArray.push(tree[index].code);
        indexs.push(index);
        data.pathTable[tree[index].code] = {
          path: [...pathArray],
          name: tree[index].name,
          indexs: [...indexs],
          selectable: tree[index].selectable,
          deptName: departmentCodeDir[tree[index].parentCode],
        };
        if (tree[index].children) {
          createPathTable(tree[index].children, pathArray, indexs);
        }
        pathArray.pop();
        indexs.pop();
      }
    };
    /**
     * 获取员工树
     */
    const getStaffTree = async () => {
      data.tree = await $api.getStaffTree({
        deptCode: departmentDir[selectNode ? selectNode.taskName : ""]
          ? departmentDir[selectNode.taskName]
          : "",
      });
      createPathTable(data.tree, [], []);
    };

    /**
     * 获取流程节点信息并回显审核人
     */
    const getProcessNodeInfoFn = async () => {
      if (props.workflowType === "common_flow" || props.workflowType === "office_supplies_use" || props.workflowType === "seal_apply" || props.workflowType === 'common_contract') return;
      if(props.workflowType){
        let result = await $api.getProcessNodeInfo(props.workflowType);
        data.currentApproval = 99;
        result.forEach((item: any, index: any) => {
          if(item.id === props.currentTask){
            data.currentApproval = index;
          }
        });
        if (data.flowList.length == 0) {
          result.forEach((item: any, index: any) => {
            data.flowList.push({
              assignee: "",
              assigneeName: "",
              taskDefinitionKey: item.id,
              taskName: item.name,
            });
          });
          ctx.emit("update:modelValue", data.flowList);
        }
      }
    };

    /**
     * 新增审核人
     */
    const appendFn = (node: any) => {
      if(props.showStatus) return;
      selectAuditUser.value = "";
      visible.value = !visible.value;
      selectNode = node;
      getStaffTree();
    };

    /**
     * 监听审核人的code变化
     */
    watch(
      () => selectAuditUser.value,
      () => {
        if (selectAuditUser.value) {
          if (selectNode !== "") {
            selectNode.assignee = selectAuditUser.value;
            selectNode.assigneeName =
              data.pathTable[selectAuditUser.value].name;
          } else {
            data.flowList.push({
              assignee: selectAuditUser.value,
              assigneeName: data.pathTable[selectAuditUser.value].name,
              taskName: data.pathTable[selectAuditUser.value].deptName,
            });
          }
          ctx.emit("update:modelValue", data.flowList);
        }
      }
    );
    /**
     * 监听modelValue变化
     */
    watch(
      () => props.modelValue,
      (val) => {
        if(val.length > 0){
          data.currentApproval = 99;
          val.forEach((item: any, index: any)=>{
            if(item.taskDefinitionKey === props.currentTask){
              data.currentApproval = index;
            }
          });
          if(data.flowList.length > 0 && (data.flowList.length === val.length)){
            data.flowList.forEach((item: any, index: any)=>{
              item.assignee = val[index].assignee;
              item.assigneeName = val[index].assigneeName;
            });
          }else{
            data.flowList = val;
          }
        }else{
          data.flowList = [];
          getProcessNodeInfoFn();
        }
      }
    );
    /**
     * 监听workflowType变化
     */
    watch(
      () => props.workflowType,
      (val) => {
        data.flowList = [];
        getProcessNodeInfoFn();
      }
    );
    /**
     * 移除审核人
     */
    const deleFn = (node: any, index: any) => {
      if (props.workflowType === "common_flow" || props.workflowType === "office_supplies_use" || props.workflowType === "seal_apply"|| props.workflowType === 'common_contract') {
        data.flowList.splice(index, 1);
      } else {
        node.assignee = "";
        node.assigneeName = "";
      }
    };
    /**
     * 修改审核人
     */
    const clickAavatarFn = (node: any) => {
      selectNode = node;
      visible.value = !visible.value;
      selectAuditUser.value = node.assignee;
      getStaffTree();
    };

    /**
     * 验证数据
     */
    const validateFn = () => {
      const result = props.modelValue.every((_: any) => _.assignee);
      if (!result) {
        ElMessage.warning({
          message: "审批流程节点未勾选完",
          type: "warning",
        });
      }
      return result;
    };

    onMounted(() => {      
      if(props.workflowType === 'material_progress_payment' || props.workflowType === 'material_prepaid_payment'){
        data.currentApproval = 99;
        props.modelValue.forEach((item: any, index: any)=>{
          if(item.taskDefinitionKey === props.currentTask){
            data.currentApproval = index;
          }
        });
     }
    });
    onActivated(() => {    
      getProcessNodeInfoFn();
    });

    return {
      data,
      validateFn,
      createPathTable,
      selectAuditUser,
      visible,
      appendFn,
      deleFn,
      clickAavatarFn,
      workType,
    };
  },
});
</script>
